(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks-wager/assets/javascripts/use-draw-forecast.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks-wager/assets/javascripts/use-draw-forecast.js');
"use strict";

const tipsenApi = svs.components.tipsen.store.tipsenApi;
const drawStateEnums = svs.components.sport.tipsenShared.drawStateEnums;
const hooksWager = svs.components.tipsen.hooksWager;
const useDrawForecast = _ref => {
  let productId = _ref.productId,
    drawNumber = _ref.drawNumber,
    _ref$skip = _ref.skip,
    skip = _ref$skip === void 0 ? false : _ref$skip;
  const drawState = hooksWager.useGetDrawState(productId, drawNumber);
  const shouldStartDrawForecastSubscription = drawState === drawStateEnums.LIVE && !skip;
  const shouldFetchDrawForecast = drawState === drawStateEnums.FINALIZED && !shouldStartDrawForecastSubscription && !skip;
  const drawForecast = tipsenApi.useGetDrawForecastQuery({
    drawNumber,
    productId
  }, {
    skip: !drawNumber || !productId || !shouldStartDrawForecastSubscription
  });
  const fetchedDrawForecast = tipsenApi.useGetDrawForecastFetchQuery({
    drawNumber,
    productId
  }, {
    skip: !drawNumber || !productId || !shouldFetchDrawForecast
  });
  return shouldFetchDrawForecast ? fetchedDrawForecast : drawForecast;
};
setGlobal('svs.components.tipsen.hooksWager.useDrawForecast', useDrawForecast);

 })(window);